/**
 * Converts seconds to hours
 * @param seconds
 * @returns {number}
 */
export function sToh(seconds) {
  return seconds / 60 / 60;
}
